/* eslint-disable no-console */
import fileSaver from 'file-saver';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import types from './productPurchaseOrder.types';
import * as productPurchaseOrderService from '../../../../services/productPurchaseOrder.service';
import * as purchaseOrderTemplateService from '../../../../services/Purchase-Order-template.service';

const ERROR_MESSAGE = 'API connection failed. Please screenshot error and contact your account manager.';

export const fetchProductDetailsForPO = (devOrderId) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.fetchProductDetailsForPO(devOrderId);
    if (response?.code === 200) {
      await dispatch({
        type: types.FETCH_PRODUCT_DETAILS,
        payload: response.data,
      });
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || ERROR_MESSAGE;
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const fetchCompanyDetailsForPO = () => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.fetchCompanyDetailsForPO();
    if (response?.code === 200) {
      await dispatch({
        type: types.FETCH_COMPANY_DETAILS,
        payload: response.data,
      });
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || ERROR_MESSAGE;
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const fetchPOTemplateDetailsForProduct = (templateId) => async (dispatch) => {
  try {
    const response = await purchaseOrderTemplateService.getPurchaseOrderTemplateDetails(templateId);

    if (response?.code === 200) {
      await dispatch({
        type: types.FETCH_PO_TEMPLATE_DETAILS,
        payload: response.data,
      });
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to fetch template details';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const clearPOTemplateDetailsForProduct = () => async (dispatch) => {
  await dispatch({
    type: types.CLEAR_PO_TEMPLATE_DETAILS,
  });
};

export const fetchFilteredDevelopmentOrders =
  (supplierId, factoryId = null, brandId = null) =>
  async (dispatch) => {
    try {
      const response = await productPurchaseOrderService.fetchFilteredDevelopmentOrders(supplierId, factoryId, brandId);
      if (response?.code === 200) {
        await dispatch({
          type: types.FETCH_FILTERED_DEVELOPMENT_ORDERS,
          payload: response.data,
        });
        return response;
      }
      const errorMsg = response?.data?.errMsg || response?.message || ERROR_MESSAGE;
      toasterMsg(errorMsg, 'danger');
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
      toasterMsg(errorMessage, 'danger');
      return { code: 500, error: errorMessage };
    }
  };

export const clearFilteredDevelopmentOrders = () => async (dispatch) => {
  await dispatch({
    type: types.CLEAR_FILTERED_DEVELOPMENT_ORDERS,
  });
};

export const fetchSupplierFactories =
  (supplierId, params = {}) =>
  async (dispatch) => {
    try {
      const response = await productPurchaseOrderService.fetchSupplierFactories(supplierId, params);
      if (response?.code === 200) {
        await dispatch({
          type: types.FETCH_SUPPLIER_FACTORIES,
          payload: response.data,
        });
        return response;
      }
      const errorMsg = response?.data?.errMsg || ERROR_MESSAGE;
      toasterMsg(errorMsg, 'danger');
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
      toasterMsg(errorMessage, 'danger');
      return { code: 500, error: errorMessage };
    }
  };

export const clearSupplierFactories = () => async (dispatch) => {
  await dispatch({
    type: types.CLEAR_SUPPLIER_FACTORIES,
  });
};

export const clearAllPOData = () => async (dispatch) => {
  await dispatch({
    type: types.CLEAR_ALL_PO_DATA,
  });
};

export const createProductPurchaseOrder = (orderData, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.createPurchaseOrder(orderData);

    if (response?.code === 200) {
      await dispatch({
        type: types.CREATE_PURCHASE_ORDER_SUCCESS,
        payload: response.data,
      });

      const message = transactionMsg ? transactionMsg('CREATE_EDIT_PO.CREATED_SUCCESS') : 'Purchase Order created successfully';
      toasterMsg(message, 'success');
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to create purchase order';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const updateProductPurchaseOrder = (orderId, orderData, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.updatePurchaseOrder(orderId, orderData);

    if (response?.code === 200) {
      await dispatch({
        type: types.UPDATE_PURCHASE_ORDER_SUCCESS,
        payload: response.data,
      });

      const message = transactionMsg ? transactionMsg('CREATE_EDIT_PO.UPDATED_SUCCESS') : 'Purchase Order updated successfully';
      toasterMsg(message, 'success');
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to update purchase order';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const rearrangePurchaseOrderSections = (orderId, sections, transactionMsg) => async () => {
  try {
    const updateData = { sections };
    const response = await productPurchaseOrderService.updatePurchaseOrder(orderId, updateData);

    if (response?.code === 200) {
      const message = transactionMsg ? transactionMsg('CREATE_EDIT_PO.REARRANGE_SUCCESS') : 'Sections rearranged successfully';
      toasterMsg(message, 'success');
    } else {
      const errorMsg = response?.data?.errMsg || response?.message || 'Failed to rearrange sections';
      toasterMsg(errorMsg, 'danger');
    }
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const updateProductPurchaseOrderActualFields =
  ({ orderId, updates, transactionMsg }) =>
  async () => {
    try {
      const response = await productPurchaseOrderService.updateActualFields(orderId, updates);
      if (response?.code === 200) {
        const message = transactionMsg ? transactionMsg('CREATE_EDIT_PO.ACTUAL_FIELDS_UPDATED') : 'Actual fields updated successfully';
        toasterMsg(message, 'success');
        return response;
      }
      const errorMsg = response?.data?.errMsg || response?.message || 'Failed to update actual fields';
      return { code: response?.code || 500, message: errorMsg };
    } catch (error) {
      const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
      return { code: 500, message: errorMessage };
    }
  };

export const fetchPurchaseOrderDetails = (orderId) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.fetchPurchaseOrderDetails(orderId);

    if (response?.code === 200) {
      await dispatch({
        type: types.FETCH_PURCHASE_ORDER_DETAILS,
        payload: response.data,
      });
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to fetch purchase order details';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    throw error;
  }
};

export const deleteProductPurchaseOrder = (orderId, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.deletePurchaseOrder(orderId);

    if (response?.code === 200) {
      await dispatch({
        type: types.DELETE_PURCHASE_ORDER_SUCCESS,
        payload: orderId,
      });

      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.DELETE_ORDER_SUCCESS') : 'Purchase Order deleted successfully';
      toasterMsg(message, 'success');
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to delete purchase order';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const bulkDeleteProductPurchaseOrders = (orderIds, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.bulkDeletePurchaseOrders(orderIds);

    if (response?.code === 200) {
      await dispatch({
        type: types.BULK_DELETE_PURCHASE_ORDERS_SUCCESS,
        payload: orderIds,
      });

      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.BULK_DELETE_SUCCESS') : 'Purchase Orders deleted successfully';
      toasterMsg(message, 'success');
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to delete purchase orders';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const fetchNewPurchaseOrdersList =
  (params = {}) =>
  async (dispatch) => {
    try {
      const response = await productPurchaseOrderService.fetchNewPurchaseOrders(params);

      if (response?.code === 200) {
        const action = params.append ? types.APPEND_PURCHASE_ORDERS : types.FETCH_PURCHASE_ORDERS_LIST;

        await dispatch({
          type: action,
          payload: response.data,
        });

        return response;
      }

      const errorMsg = response?.data?.errMsg || response?.message || 'Failed to fetch new purchase orders';
      toasterMsg(errorMsg, 'danger');
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
      toasterMsg(errorMessage, 'danger');
      throw error;
    }
  };

export const fetchOldPurchaseOrdersList =
  (params = {}) =>
  async (dispatch) => {
    try {
      const response = await productPurchaseOrderService.fetchOldPurchaseOrders(params);

      if (response?.code === 200) {
        const action = params.append ? types.APPEND_OLD_PURCHASE_ORDERS : types.FETCH_OLD_PURCHASE_ORDERS;

        await dispatch({
          type: action,
          payload: response.data,
        });

        return response;
      }

      const errorMsg = response?.data?.errMsg || response?.message || 'Failed to fetch old purchase orders';
      toasterMsg(errorMsg, 'danger');
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
      toasterMsg(errorMessage, 'danger');
      throw error;
    }
  };

export const fetchPurchaseOrdersList =
  (params = {}) =>
  async (dispatch) => {
    const newPOsResponse = await dispatch(fetchNewPurchaseOrdersList(params));

    if (newPOsResponse?.code === 200) {
      const newPOsCount = newPOsResponse?.data?.data?.length || 0;
      const requestedPageSize = params.pageSize || 20;

      if (newPOsCount < requestedPageSize && !params.append) {
        const oldPOsNeeded = requestedPageSize - newPOsCount;
        if (oldPOsNeeded > 0) {
          await dispatch(
            fetchOldPurchaseOrdersList({
              ...params,
              pageSize: oldPOsNeeded,
              pageIndex: 1,
            }),
          );
        }
      }
    }

    return newPOsResponse;
  };

export const createPurchaseOrderFile = (fileData, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.createOrderFile(fileData);

    if (response?.code === 200) {
      await dispatch({
        type: types.UPLOAD_PO_FILE_SUCCESS,
        payload: response.data,
      });
      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.FILES.UPLOAD_SUCCESS') : 'File uploaded successfully';
      toasterMsg(message, 'success');
      return response;
    }

    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to upload file';
    toasterMsg(errorMsg, 'danger');
    throw new Error(errorMsg);
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    throw error;
  }
};

export const fetchPurchaseOrderFilesList =
  (poId, params = {}) =>
  async (dispatch) => {
    try {
      const response = await productPurchaseOrderService.getOrderFilesList(poId, params);

      if (response?.code === 200) {
        await dispatch({
          type: types.FETCH_PO_FILES_LIST,
          payload: response.data,
        });
        return response;
      }

      const errorMsg = response?.data?.errMsg || response?.message || 'Failed to fetch files';
      toasterMsg(errorMsg, 'danger');
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
      toasterMsg(errorMessage, 'danger');
      throw error;
    }
  };

export const fetchPurchaseOrderFileDetails = (fileId) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.getOrderFileDetails(fileId);

    const actualData = response?.data?.data || response?.data || response;
    const responseCode = response?.data?.code || response?.code;

    if (responseCode === 200) {
      await dispatch({
        type: types.FETCH_PO_FILE_DETAILS,
        payload: actualData,
      });
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to fetch file details';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    toasterMsg(error?.response?.data?.message || 'Failed to fetch file details', 'danger');
    throw error;
  }
};

export const updatePurchaseOrderFile = (fileId, fileData, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.updateOrderFile(fileId, fileData);
    if (response?.code === 200) {
      await dispatch({
        type: types.UPDATE_PO_FILE_SUCCESS,
        payload: response.data,
      });
      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.FILES.UPDATE_SUCCESS') : response?.message || 'File updated successfully';
      toasterMsg(message, 'success');
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to update file';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    toasterMsg(error?.response?.data?.message || 'Failed to update file', 'danger');
    throw error;
  }
};

export const deletePurchaseOrderFile = (fileId, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.deleteOrderFile(fileId);

    if (response?.code === 200) {
      await dispatch({
        type: types.DELETE_PO_FILE_SUCCESS,
        payload: fileId,
      });

      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.FILES.FILE_DELETED_SUCCESS') : 'File deleted successfully';
      toasterMsg(message, 'success');
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to delete file';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const bulkDeletePurchaseOrderFiles = (fileIds, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.bulkDeleteOrderFiles(fileIds);

    if (response?.code === 200) {
      await dispatch({
        type: types.BULK_DELETE_PO_FILES_SUCCESS,
        payload: fileIds,
      });

      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.FILES.FILES_DELETED_SUCCESS') : `${fileIds.length} file(s) deleted successfully`;
      toasterMsg(message, 'success');
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to delete files';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const deleteOldPurchaseOrder = (orderId, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.deleteOldPurchaseOrder(orderId);

    if (response?.code === 200) {
      await dispatch({
        type: types.DELETE_OLD_PURCHASE_ORDER_SUCCESS,
        payload: orderId,
      });

      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.DELETE_ORDER_SUCCESS') : 'Old Purchase Order deleted successfully';
      toasterMsg(message, 'success');
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to delete old purchase order';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const bulkDeleteOldPurchaseOrders = (orderIds, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.bulkDeleteOldPurchaseOrders(orderIds);

    if (response?.code === 200) {
      await dispatch({
        type: types.BULK_DELETE_OLD_PURCHASE_ORDERS_SUCCESS,
        payload: orderIds,
      });

      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.BULK_DELETE_SUCCESS') : 'Old Purchase Orders deleted successfully';
      toasterMsg(message, 'success');
      return response;
    }
    const errorMsg = response?.data?.errMsg || response?.message || 'Failed to delete old purchase orders';
    toasterMsg(errorMsg, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const downloadPurchaseOrderPDF =
  (poId, transactionMsg, distributionCenters = null) =>
  async (dispatch) => {
    try {
      const response = await productPurchaseOrderService.downloadPOPDF(poId, distributionCenters);
      if (response?.data) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const contentDisposition = response.headers['content-disposition'];
        let filename = `PO-${poId}-${new Date().toISOString().split('T')[0]}.pdf`;

        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
          if (filenameMatch) {
            filename = filenameMatch[1];
          }
        }

        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        await dispatch({
          type: types.DOWNLOAD_PO_PDF,
          payload: { poId, downloadedAt: new Date().toISOString() },
        });

        const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.PDF_DOWNLOAD_SUCCESS') : 'PDF downloaded successfully';
        toasterMsg(message, 'success');

        return { code: 200, success: true };
      }

      throw new Error('No data received for PDF download');
    } catch (error) {
      const errorMessage = error?.response?.data?.errMsg || error?.message || 'Failed to download PDF';
      toasterMsg(errorMessage, 'danger');
      return { code: 500, error: errorMessage };
    }
  };

export const updatePOStatus = (orderId, statusData, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.updatePOStatus(orderId, statusData);
    if (response?.code === 200) {
      await dispatch({
        type: types.UPDATE_PO_STATUS_SUCCESS,
        payload: { orderId, ...response.data },
      });

      const message = transactionMsg
        ? transactionMsg(`PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.${statusData.status.toUpperCase()}_SUCCESS`)
        : `Purchase Order ${statusData.status} successfully`;
      toasterMsg(message, 'success');

      return response;
    }

    const errorMessage = response?.data?.errMsg || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const cancelPO = (orderId, cancelData, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.cancelPO(orderId, cancelData);
    if (response?.code === 200) {
      await dispatch({
        type: types.UPDATE_PO_STATUS_SUCCESS,
        payload: { orderId, ...response.data },
      });

      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.CANCELLED_SUCCESS') : 'Purchase Order cancelled successfully';
      toasterMsg(message, 'success');

      return response;
    }

    const errorMessage = response?.data?.errMsg || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const deliverPO = (orderId, deliverData, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.deliverPO(orderId, deliverData);
    if (response?.code === 200) {
      await dispatch({
        type: types.UPDATE_PO_STATUS_SUCCESS,
        payload: { orderId, ...response.data },
      });

      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.DELIVERED_SUCCESS') : 'Purchase Order delivered successfully';
      toasterMsg(message, 'success');

      return response;
    }

    const errorMessage = response?.data?.errMsg || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const revisePO = (orderId, transactionMsg) => async (dispatch) => {
  try {
    const response = await productPurchaseOrderService.revisePO(orderId);
    if (response?.code === 200) {
      await dispatch({
        type: types.UPDATE_PO_STATUS_SUCCESS,
        payload: { orderId, ...response.data },
      });

      const message = transactionMsg ? transactionMsg('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.REVISED_SUCCESS') : 'Purchase Order revised successfully';
      toasterMsg(message, 'success');

      return response;
    }

    const errorMessage = response?.data?.errMsg || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const fetchPOLogsAndHistory = (purchaseOrderId) => async (dispatch) => {
  try {
    if (!purchaseOrderId) {
      const errorMessage = 'Purchase Order ID is required';
      toasterMsg(errorMessage, 'danger');
      return { code: 400, error: errorMessage };
    }

    const response = await productPurchaseOrderService.fetchPOLogsAndHistory(purchaseOrderId);

    if (response?.code === 200) {
      await dispatch({
        type: types.FETCH_PO_LOGS_AND_HISTORY,
        payload: response.data,
      });

      return response;
    }

    const errorMessage = response?.data?.errMsg || 'Failed to fetch PO logs and history';
    toasterMsg(errorMessage, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const fetchPOLogById = (logId) => async (dispatch) => {
  try {
    if (!logId) {
      const errorMessage = 'Log ID is required';
      toasterMsg(errorMessage, 'danger');
      return { code: 400, error: errorMessage };
    }

    const response = await productPurchaseOrderService.fetchPOLogById(logId);

    if (response?.code === 200) {
      await dispatch({
        type: types.FETCH_PO_LOG_BY_ID,
        payload: response.data,
      });

      return response;
    }

    const errorMessage = response?.data?.errMsg || 'Failed to fetch PO log entry';
    toasterMsg(errorMessage, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const fetchPOLogDetailsById = (logId) => async (dispatch) => {
  try {
    if (!logId) {
      const errorMessage = 'Log ID is required';
      toasterMsg(errorMessage, 'danger');
      return { code: 400, error: errorMessage };
    }

    const response = await productPurchaseOrderService.fetchPOLogDetailsById(logId);

    if (response?.code === 200) {
      await dispatch({
        type: types.FETCH_PO_LOG_DETAILS_BY_ID,
        payload: response.data,
      });

      return response;
    }

    const errorMessage = response?.data?.errMsg || 'Failed to fetch detailed PO log entry';
    toasterMsg(errorMessage, 'danger');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data?.errMsg || error?.message || ERROR_MESSAGE;
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

export const downloadPOSampleSheet = () => async () => {
  try {
    const blob = await productPurchaseOrderService.downloadPOSampleExcel();
    if (blob) {
      fileSaver.saveAs(blob, 'Sample Purchase Order.xlsx');
    }
  } catch (error) {
    toasterMsg('Failed to download PO sample', 'danger');
  }
};
